import { Button, Card, Col, Form, Input, Row, Tag, notification } from "antd";
import { MailOutlined, SaveOutlined, UserOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { UPDATE_ADMIN_PROFILE } from "../../apis/apis";
import CulsightPageLoader from "../../components/CulsightPageLoader";

function Setting() {
    const [form] = Form.useForm();

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [role, setRole] = useState("");
    const [loading, setLoading] = useState(false); // page-level loader

    // Fetch profile
    const getProfile = async () => {
        setLoading(true);
        try {
            const res = await UPDATE_ADMIN_PROFILE();
            if (res?.data?.status) {
                const data = res?.data?.data;

                setFirstName(data?.first_name || "");
                setLastName(data?.last_name || "");
                setEmail(data?.email || "");
                setRole(data?.roles || "");

                form.setFieldsValue({
                    first_name: data?.first_name,
                    last_name: data?.last_name,
                });
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getProfile();
    }, []);

    // Submit (edit mode)
    const onFinish = async (values) => {
        setLoading(true); // use page loader
        const FORM_DATA = new FormData();
        FORM_DATA.append("first_name", values.first_name);
        FORM_DATA.append("last_name", values.last_name);

        try {
            const res = await UPDATE_ADMIN_PROFILE(FORM_DATA);

            if (res?.data?.status) {
                notification.success({
                    message: "Success",
                    description: res?.data?.message,
                });
                getProfile(); // refresh
            } else {
                notification.error({
                    message: "Error",
                    description: res?.data?.message,
                });
            }
        } catch (error) {
            notification.error({
                message: "Server Error",
                description:
                    error?.response?.data?.message || "Something went wrong",
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="lms-body">
            <h1>Settings</h1>
            <span style={{ color: "#6c757d", fontSize: "14px" }}>
                Manage your account and preferences
            </span>

            {loading ? (
                <CulsightPageLoader />
            ) : (
                <Card style={{ marginTop: "15px" }}>
                    <h2>
                        <UserOutlined style={{ color: "#8c3add" }} /> Profile Information
                    </h2>

                    {/* Profile Header */}
                    <div style={{ display: "flex" }}>
                        <Tag
                            color="#8c3add"
                            style={{ marginTop: "10px", padding: "40px", borderRadius: "50%" }}
                        >
                            <h1 style={{ fontSize: "35px" }}>{firstName?.charAt(0)}</h1>
                        </Tag>

                        <div style={{ marginTop: "10px", marginLeft: "20px" }}>
                            <h2>{firstName} {lastName}</h2>
                            <span style={{ color: "gray" }}>{email}</span>
                            <br />
                            <Tag color="#ede9fe">
                                <span style={{ color: "#8c3add", fontWeight: "bold" }}>
                                    {role}
                                </span>
                            </Tag>
                        </div>
                    </div>

                    <hr />

                    {/* Form */}
                    <Form
                        layout="vertical"
                        form={form}
                        onFinish={onFinish}
                        style={{ marginTop: "15px" }}
                    >
                        <Row gutter={[16, 16]}>
                            <Col span={12}>
                                <Form.Item
                                    name="first_name"
                                    label={
                                        <span style={{ fontWeight: "bold" }}>
                                            <UserOutlined style={{ color: "#8c3add" }} /> First Name
                                        </span>
                                    }
                                    rules={[{ required: true, message: "Enter first name" }]}
                                >
                                    <Input
                                        value={firstName}
                                        onChange={(e) => setFirstName(e.target.value)}
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={12}>
                                <Form.Item
                                    name="last_name"
                                    label={
                                        <span style={{ fontWeight: "bold" }}>
                                            <UserOutlined style={{ color: "#8c3add" }} /> Last Name
                                        </span>
                                    }
                                    rules={[{ required: true, message: "Enter last name" }]}
                                >
                                    <Input
                                        value={lastName}
                                        onChange={(e) => setLastName(e.target.value)}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={[16, 16]}>
                            <Col span={12}>
                                <Form.Item label="Email Address">
                                    <Input value={email} disabled />
                                </Form.Item>
                            </Col>

                            <Col span={12}>
                                <Form.Item label="Role">
                                    <Input value={"Admin"} disabled />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Button
                            type="primary"
                            htmlType="submit"
                            style={{ marginTop: "15px" }}
                        >
                            <SaveOutlined /> Save Changes
                        </Button>
                    </Form>
                </Card>
            )}
        </div>
    );
}

export default Setting;